/**
 * releasePathConfig.js
 * Chemins de remise du code de transmission (release_path) — PF-03 CP3.1.
 * Référence : spec crypto v1.1.1 §2.4 et §3.3 ; DEC-037.
 *
 * Une entrée par valeur du CHECK SQL beneficiaries_release_path_check
 * (migration 20260913140000). Phase A : self_custody actif, notary affiché
 * désactivé, les quatre autres masqués.
 *
 * storageInstruction : fonction (prénom) → consigne affichée sur l'écran du
 * code 24 mots ; null pour un chemin non sélectionnable.
 */

export const RELEASE_PATHS = [
  {
    value: 'self_custody',
    label: 'Je conserve le code moi-même (papier)',
    description:
      'Vous imprimez le code et le rangez en lieu sûr, distinct de votre coffre numérique et si possible de votre logement.',
    availability: 'active',
    storageInstruction: (firstName) =>
      `Ce code permettra à ${firstName} d'accéder aux données que vous lui destinez. Imprimez-le et conservez-le hors de votre coffre numérique. Sans ce code, la transmission sera impossible.`,
  },
  {
    value: 'notary',
    label: 'Chez mon notaire (testament)',
    description:
      'Le code est écrit à la main dans un testament déposé chez votre notaire.',
    availability: 'coming_soon',
    storageInstruction: null,
  },
  {
    value: 'commissaire',
    label: 'Chez un commissaire de justice',
    description: '',
    availability: 'hidden',
    storageInstruction: null,
  },
  {
    value: 'avocat',
    label: 'Chez un avocat séquestre',
    description: '',
    availability: 'hidden',
    storageInstruction: null,
  },
  {
    value: 'escrow',
    label: 'Chez un tiers de confiance qualifié',
    description: '',
    availability: 'hidden',
    storageInstruction: null,
  },
  {
    value: 'threshold',
    label: 'Partagé entre plusieurs bénéficiaires',
    description: '',
    availability: 'hidden',
    storageInstruction: null,
  },
];

export const DEFAULT_RELEASE_PATH = 'self_custody';

/**
 * @param {unknown} value
 * @returns {boolean} Vrai si value est une valeur du CHECK SQL.
 */
export const isValidReleasePath = (value) => RELEASE_PATHS.some((p) => p.value === value);

/**
 * @param {unknown} value
 * @returns {object|null} Entrée de RELEASE_PATHS, ou null si inconnue.
 */
export const getReleasePath = (value) => RELEASE_PATHS.find((p) => p.value === value) || null;
